import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged';
import Contrato from '../../../../components/auth/contratos/listar/contrato';
import Head from '../../../../components/head';
import Footer from '../../../../components/footer';


function ContratoScreen () {
    return (
        <Fragment>
            <Head titulo="Visualizando Contrato" />
            <HeaderLogged />
            <Container>
                <Contrato />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContratoScreen;